import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { tr } from '../utils/locale';
import Script from '../utils/Script';
import AsyncSelect from '../Select/AsyncSelect';

export default class AddressAutocomplete extends Component {
    constructor(props) {
        super(props);
        const { defaultValue } = props;

        this.state = {
            menuIsOpen: false,
            inputValue: defaultValue || '',
            value: null,
        };
        this.selectRef = React.createRef();
    }

    componentDidMount() {
        const { defaultValue, isDefaultClose } = this.props;
        if (defaultValue) {
            this.loadAddresses(defaultValue, null, isDefaultClose);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.multisearchTimeout);
    }

    clearValue = () => {
        if (this.selectRef.current && this.selectRef.current.select && this.selectRef.current.select.select) {
            this.selectRef.current.select.select.clearValue();
        }
    };

    getOptions = () => {
        const {
            woosmapKey,
            language,
            apiOrder,
            componentsLocalities,
            biasLocalities,
            componentsAddress,
            disableAddress,
            localitiesTypes,
        } = this.props;
        const options = {
            debounceTime: 100,
            apiOrder,
            localities: {
                key: woosmapKey,
                fallbackBreakpoint: false,
                params: {
                    components: componentsLocalities,
                    types: localitiesTypes,
                    location: biasLocalities,
                    language,
                },
            },
        };
        if (!disableAddress) {
            options.address = {
                key: woosmapKey,
                fallbackBreakpoint: false,
                params: {
                    components: componentsAddress,
                    language,
                },
            };
        }
        return options;
    };

    createMultisearch = () => {
        if (this.scriptLoaded) {
            this.multisearch = window.woosmap.multisearch(this.getOptions());
        }
    };

    multisearchScriptLoaded = () => {
        if (window.woosmap && window.woosmap.multisearch) {
            this.scriptLoaded = true;
        } else {
            this.multisearchTimeout = setTimeout(this.multisearchScriptLoaded, 200);
        }
    };

    getRequestparams = () => {
        const { woosmapKey } = this.props;
        return {
            key: woosmapKey,
        };
    };

    onChange = (selected) => {
        this.setState({
            value: selected,
        });
        if (!this.multisearch || !selected) {
            return;
        }
        const { callback } = this.props;
        const [id, api] = selected.value.split('||');
        this.multisearch
            .detailsMulti({ id, api })
            .then((response) => {
                callback(response);
            })
            .catch(() => {
                // do nothing
            });
    };

    onInputChange = (value, { action }) => {
        const { inputChangeCb } = this.props;
        if (action === 'menu-close') {
            this.setState({ menuIsOpen: false });
            return;
        }
        if (action === 'input-blur') return;
        this.setState({ inputValue: value });
        if (inputChangeCb) {
            inputChangeCb(value);
        }
    };

    loadAddresses = (newValue, callback, isDefaultClose) => {
        this.createMultisearch();
        if (!this.multisearch) {
            return;
        }
        this.setState({ menuIsOpen: !isDefaultClose });
        this.multisearch
            .autocompleteMulti(newValue, this.getOptions())
            .then((response) => {
                const result = response.map((item) => ({
                    value: `${item.id}||${item.api}`,
                    label: item.description,
                }));
                if (callback) {
                    callback(result);
                }
            })
            .catch(() => {
                // do nothing
            });
    };

    render() {
        const { selectedLocality, menuIsOpen, inputValue, value } = this.state;
        const { placeholder } = this.props;
        return (
            <>
                <Script
                    url="https://sdk.woosmap.com/multisearch/multisearch.js"
                    onLoad={this.multisearchScriptLoaded}
                    onError={this.multisearchScriptError}
                />
                <AsyncSelect
                    innerRef={this.selectRef}
                    blurInputOnSelect
                    isClearable
                    escapeClearsValue
                    loadOptions={this.loadAddresses}
                    onChange={this.onChange}
                    onInputChange={this.onInputChange}
                    placeholder={placeholder}
                    onBlur={() => this.setState({ menuIsOpen: false })}
                    menuIsOpen={menuIsOpen}
                    defaultValue={selectedLocality}
                    value={value}
                    inputValue={inputValue}
                />
            </>
        );
    }
}

AddressAutocomplete.defaultProps = {
    placeholder: tr('Type in an address'),
    defaultValue: null,
    apiOrder: ['localities', 'address'],
    language: null,
    localitiesTypes: ['address'],
    componentsLocalities: { country: ['fr', 'gb'] },
    biasLocalities: null,
    disableAddress: false,
    isDefaultClose: false,
    componentsAddress: null,
    inputChangeCb: null,
};
AddressAutocomplete.propTypes = {
    woosmapKey: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    apiOrder: PropTypes.array,
    localitiesTypes: PropTypes.array,
    componentsLocalities: PropTypes.object,
    biasLocalities: PropTypes.string,
    componentsAddress: PropTypes.string,
    placeholder: PropTypes.string,
    language: PropTypes.string,
    disableAddress: PropTypes.bool,
    isDefaultClose: PropTypes.bool,
    callback: PropTypes.func.isRequired,
    inputChangeCb: PropTypes.func,
};
